import { formatDateTime } from '@crm/shared';
import { WhatsAppDeliveryStatus } from '../whatsAppMessage/WhatsAppDeliveryStatus';
import { WhatsAppMediaContent } from '../whatsAppMessage/WhatsAppMediaContent';
import {
  isWhatsAppMediaType,
  type WhatsAppMessage,
} from '../whatsAppMessage/whatsAppMessageTypes';

/**
 * WHATSAPP MESSAGE BUBBLES — i messaggi come bolle: IN a sinistra, OUT a destra,
 * con media (vocali, allegati) ed esito dell'invio. Lo usano la sessione nella
 * scheda del contatto e la pagina WhatsApp (FILO-37), che così non divergono.
 */
interface WhatsAppMessageBubblesProps {
  messages: WhatsAppMessage[];
}

export function WhatsAppMessageBubbles({ messages }: WhatsAppMessageBubblesProps) {
  return (
    <div className="whatsapp-chat">
      {messages.map((message) => (
        <div
          key={message.whatsAppMessageId}
          className={
            message.direction === 'OUT'
              ? 'wa-bubble wa-bubble--out'
              : 'wa-bubble wa-bubble--in'
          }
        >
          {isWhatsAppMediaType(message.type) && (
            <WhatsAppMediaContent message={message} />
          )}
          {message.body && (
            <span className="wa-bubble__body">{message.body}</span>
          )}
          <span className="wa-bubble__time">
            {formatDateTime(message.receiptDate)}
            <WhatsAppDeliveryStatus message={message} />
          </span>
        </div>
      ))}
    </div>
  );
}

export default WhatsAppMessageBubbles;
